module.exports = __webpack_public_path__ + "static/media/where-workl.26db86e0.svg";